import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../App";

/**
 * Fetches the user's entitlement summary for the Query-page banner.
 *
 * Returns { entitlements, loading, refresh } where `entitlements` includes
 * trial / free / paid / subscription counts and `can_submit`. Counts only — never PHI.
 */
export const useEntitlements = () => {
  const [entitlements, setEntitlements] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/billing/entitlements`);
      setEntitlements(res.data?.data || null);
    } catch {
      /* non-fatal: banner simply hides itself */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { entitlements, loading, refresh };
};

export default useEntitlements;
